import { Input as ChakraInput } from '@chakra-ui/react'
import type { InputProps } from '@chakra-ui/react'

export const Input = (props: InputProps) => {
  return <ChakraInput borderColor="brand.box.border" _hover={{ borderColor: 'brand.box.border' }} {...props} />
}
